import { KeyboardArrowUp } from '@mui/icons-material';
import { useScrollTrigger, Zoom } from '@mui/material';
import React, { useCallback } from 'react';
import { ScrollToTopButtonWrap, ScrollToTopFab } from './style';

function ScrollToTopButton() {
	const trigger = useScrollTrigger({
		threshold: 100,
		disableHysteresis: true,
		target: window,
	});

	const scrollToTop = useCallback(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}, []);

	return (
		<Zoom in={trigger}>
			<ScrollToTopButtonWrap>
				<ScrollToTopFab
					onClick={scrollToTop}
					size="small"
					aria-label="Scroll back to top"
				>
					<KeyboardArrowUp fontSize="medium" color="primary" />
				</ScrollToTopFab>
			</ScrollToTopButtonWrap>
		</Zoom>
	);
}
export default ScrollToTopButton;
